import React from 'react';
import { ShoppingBag, Clock, Truck, CreditCard } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { LINKS } from '../config/links';

const OrderSection = () => {
  return (
    <section id="commander" className="py-20 lg:py-28 bg-gradient-to-br from-amber-600 via-amber-700 to-amber-800 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-200 font-semibold text-sm uppercase tracking-wider mb-3">
            Commandez en ligne
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Livraison & À Emporter
          </h2>
          <p className="text-lg text-amber-100 max-w-2xl mx-auto">
            Commandez directement via Uber Eats et régalez-vous
            avec nos spécialités fraîches et savoureuses.
          </p>
        </div>

        {/* Main CTA */}
        <div className="max-w-lg mx-auto mb-12">
          <a
            href={LINKS.uberEats}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <Button
              size="lg"
              className="w-full bg-white text-amber-700 hover:bg-amber-50 px-8 py-8 text-xl font-bold shadow-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <ShoppingBag className="w-6 h-6 mr-3" />
              Ouvrir Uber Eats
            </Button>
          </a>
        </div>

        {/* Options Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Livraison */}
          <Card className="bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/20 transition-all duration-300">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Truck className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Livraison</h3>
              <p className="text-amber-100">
                Livré chez vous via Uber Eats. Rapide et pratique.
              </p>
            </CardContent>
          </Card>

          {/* À Emporter */}
          <Card className="bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/20 transition-all duration-300">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <CreditCard className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">À Emporter</h3>
              <p className="text-amber-100">
                Commandez et récupérez sur place. Offre 3 pizzas à 19,99€ !
              </p>
            </CardContent>
          </Card>

          {/* Horaires */}
          <Card className="bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/20 transition-all duration-300">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Clock className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Horaires</h3>
              <p className="text-amber-100">
                Ouvert tous les jours jusqu'à 23:30.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Contact Info */}
        <div className="mt-12 bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-center">
            <p className="text-white">
              <span className="font-semibold">Adresse :</span> {LINKS.address}
            </p>
            {LINKS.phone && (
              <a
                href={`tel:${LINKS.phone}`}
                className="text-amber-200 hover:text-white font-semibold transition-colors"
              >
                Tél : {LINKS.phoneDisplay}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderSection;
